import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => {
    return {
        quizRowContainer: {
            overflowX: 'scroll',
            width: '100%',
            height: 350,
            display: 'flex',
            marginTop: 'auto',
            marginBottom: 'auto',
            '@media (max-height: 690px)': {
                height: 250,
            },
        },
        quizRow: {
            flex: 1,
            margin: 0,
            height: `100%`,
            overflow: 'auto',
            padding: 10,
            display: 'flex',
            flexDirection: 'column',
            flexWrap: 'wrap',
            paddingLeft: '16px',
            gap: 12,
        },
        colorItem: {
            width: '100%',
            height: '100%',
            borderRadius: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-end',
            cursor: 'pointer',
            overflow: 'hidden',
            position: 'relative',
        },
        buttonContinue: {
            color: 'white',
            textDecoration: 'none',
            textTransform: 'none',
        },
        itemTitle: {
            fontFamily: 'PoppinsRegular',
            margin: 0,
            padding: 0,
            paddingTop: 4,
            fontSize: 14,
            fontWeight: 600,
            letterSpacing: -0.5,
            color: theme.palette.primary.light,
        },
        wrapperItem: {
            background: theme.palette.primary.dark,
            padding: 4,
        },
    };
});
